import React from "react";
import {StringBuilder} from "../../AppUtils";
import {BriefWhereInfo} from "../utils.jsx";
import {getWhenSectionTitleForBrief} from "../../event/OrderInformationCard/utils";
import {kosherOptions} from "../../admin/upload/AdminUploadUtils.jsx";
import {openWindow} from "../../http/WindowOpener.jsx";
import {PaymentType, ValidateBookingError} from "../../consts.js";
import {TEN_BIS_CARD_LENGTH} from "../../marketplace/MarketplaceBooking/consts.jsx";
import {getOrderPrice, getTotalBudget} from "../../utils/calculationUtils.jsx";
import {message} from "antd";

export const generateSquareBriefInfo = (briefInfo, bidInfo) => {
    if (!briefInfo) {
        return [];
    }

    return [
        {
            row: [
                {
                    title: "🏢 איפה?",
                    component: <BriefWhereInfo briefInfo={briefInfo} />
                },
                {
                    title: "📅 מתי?",
                    component: (
                        <div>
                            {getWhenSectionTitleForBrief({
                                ...bidInfo,
                                until: bidInfo?.dtstart,
                                dtstart: bidInfo?.dtstart - 2 * 60 * 60 * 1000
                            })}
                            {bidInfo?.dtstart !== briefInfo?.dtstart && (
                                <div>
                                    <b>מועד האספקה שבחרת שונה לפי זמינות בית העסק</b>
                                </div>
                            )}
                        </div>
                    ),
                    shouldShow: true
                },
                {
                    title: "🙎 מספר משתתפים",
                    component: <div>{briefInfo?.participantsAmount}</div>,
                    shouldShow: true
                },
                {
                    title: "🙎‍  תקציב להזמנה (כולל מע״מ)",
                    component: <b style={{fontSize: 30}}>₪ {briefInfo?.maxPrice}</b>,
                    shouldShow: true
                }
            ]
        }
    ];
};

export const generateBriefRowsInfo = briefInfo => {
    if (!briefInfo) {
        return [];
    }

    return [
        {
            title: "📃 פרטים נוספים",
            component: <div>{briefInfo?.description}</div>,
            shouldShow: true
        }
    ];
};

export const shouldShowKosherCertificate = providerDetails =>
    providerDetails?.kosherCertificateImageUrl &&
    (providerDetails?.kosher === kosherOptions[0] || providerDetails?.kosher === kosherOptions[2]);

export const generateBidAdditionalInfo = bidInfo => {
    const providerDetails = bidInfo?.providerDetails;
    const row = [];

    if (bidInfo?.providerNote) {
        row.push({
            title: new StringBuilder().append("✍️").append("דגשים נוספים").toString(),
            component: <div>{bidInfo.providerNote}</div>
        });
    }

    if (providerDetails?.kosher) {
        const hasKosherCertificate = shouldShowKosherCertificate(providerDetails);

        row.push({
            title: new StringBuilder().append("✡️").append(providerDetails.kosher).toString(),
            component: (
                <>
                    {hasKosherCertificate && providerDetails?.kosherCertificateImageUrl ? (
                        <a onClick={() => openWindow(providerDetails.kosherCertificateImageUrl, "_blank", true)}>
                            תעודת כשרות להורדה
                        </a>
                    ) : providerDetails.kosher === kosherOptions[1] ? (
                        <div>בית עסק לא כשר</div>
                    ) : null}
                </>
            )
        });
    }

    return row.length > 0 ? [{row}] : [];
};

export const calculatePackagePrice = bidInfo => {
    if (!bidInfo?.package?.options) return 0;
    return bidInfo.package.options.reduce((acc, item) => acc + (item.amount || 0) * (item.price || 0), 0);
};

export const calculateTotalPrice = bidInfo => {
    const packagePrice = bidInfo?.price || calculatePackagePrice(bidInfo);
    const deliveryPrice = bidInfo?.deliveryPrice || 0;
    return packagePrice + deliveryPrice;
};

export const calculatePriceWithoutVAT = price => {
    const VAT_RATE = 1.17;
    return (price / VAT_RATE).toFixed(2);
};

export const validateBooking = (
    me,
    paymentType,
    totalPrice,
    company,
    formValues,
    creditCard,
    deliveryPrice,
    couponDiscountAmount,
    companyDiscountAmount,
    originalTotalPrice = 0,
    services
) => {
    if (!paymentType) {
        return ValidateBookingError.NO_PAYMENT_TYPE;
    }

    if (paymentType === PaymentType.Card && !creditCard) {
        return ValidateBookingError.NO_PAYMENT_TYPE_CREDIT_CARD;
    }

    if (paymentType === PaymentType.TenBisCard && (formValues.tenBisCreditCard?.length || 0) < TEN_BIS_CARD_LENGTH) {
        return ValidateBookingError.NO_PAYMENT_TYPE_TEN_BIS_CARD;
    }

    if (!formValues.invoicePONumber?.length && (company?.requirePONumber || me?.isMustProvidePurchaseOrderNumber)) {
        return ValidateBookingError.NO_INVOICE_PO_NUMBER;
    }

    const currentTotalOrderPrice = getOrderPrice({
        offeredPrice: totalPrice,
        companyDiscountAmount,
        couponDiscountAmount,
        deliveryPrice: deliveryPrice ?? 0,
        tip: formValues?.tip
    });
    const hasUserEnoughMoney =
        getTotalBudget(me?.budget, services) >= currentTotalOrderPrice - (originalTotalPrice ?? 0);
    if (paymentType === PaymentType.Budget && !hasUserEnoughMoney) {
        return ValidateBookingError.BUDGET_NOT_ENOUGH;
    }
};
